// Idle-time prefetch of heavy lazy chunks so their first real use (e.g.
// generating an invoice PDF) doesn't pay the network cost. Fire-and-forget:
// a failed prefetch is harmless — the real import will retry it.

/**
 * The dynamic import is intentionally allowed here: prefetching a lazy chunk
 * IS the feature — importing it statically would defeat the code split.
 */
function prefetchLazyChunks(): void {
  void import('@/lib/invoicing/pdf-engine').catch(() => {
    // Ignore: purely opportunistic warmup.
  });
}

/** Called once from App.vue after mount. */
export function useIdlePrefetch(): void {
  if (typeof window === 'undefined') return;

  // typeof check (instead of `in`) so TS doesn't narrow `window` to never
  // in the else branch on lib targets that always declare requestIdleCallback.
  if (typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(() => prefetchLazyChunks(), { timeout: 10000 });
  } else {
    window.setTimeout(() => prefetchLazyChunks(), 3000);
  }
}
